module.exports = __webpack_public_path__ + "img/block02.894792e7.webp";